const userAgent = state => state.app.userAgent;
const ip = state => state.app.ip;
const deviceType = state => state.app.deviceType;

const screenHeight = state => state.app.screenHeight;
const screenWidth = state => state.app.screenWidth;

const countries = state => state.app.countries;

const languagesList = state => state.app.languages;
const language = state => state.app.language;
const translation = state => state.app.translation;

const displayLoader = state => state.app.displayLoader;
const displayModal = state => state.app.displayModal;
const displayMenu = state => state.app.displayMenu;
const displayProfile = state => state.app.displayProfile;

export default {
  userAgent,
  ip,
  deviceType,

  screenHeight,
  screenWidth,

  countries,

  languagesList,
  language,
  translation,

  displayLoader,
  displayModal,
  displayMenu,
  displayProfile,
};
